import type { I18n } from "@bounce/i18n"
import { i18next } from "@bounce/i18n"
import { getWalkingTimeInMinutes } from "@bounce/util"

export const getWalkingTime = (distance: number, i18n: I18n = i18next) => {
  const totalMinutes = getWalkingTimeInMinutes(distance)
  const hours = Math.floor(totalMinutes / 60)
  const minutes = Math.ceil(totalMinutes % 60)

  return hours > 0
    ? i18n.t("store:helpers.distance.walkingTimeInHoursAndMinutes", "{hours}h {minutes}m", { hours, minutes })
    : i18n.t("store:helpers.distance.walkingTimeInMinutesOnly", "{minutes} min", {
        minutes: minutes <= 0 ? 1 : minutes,
      })
}
